import { Entity, FullName, Options } from 'api';

import capitalizeFirstLetter from './capitalizeFirstLetter';

export function createOptions(values: string[]): Options<string, string>[] {
  return values.map((value) => ({
    value,
    label: value,
  }));
}

export const createOptionFromEntity = (data: Entity[]): Options<number, string>[] =>
  data.map(({ id, name }) => ({ label: name, value: id }));

export const createOptionFromFullName = (data: FullName[]): Options<string, string>[] =>
  data.map(({ cd_id, first_name, last_name }) => ({
    label: `${first_name} ${last_name}`,
    value: cd_id,
  }));

export const createOptionFromString = (
  data: string[],
  { isCapitalizeFirstLetter = false, makeValueNumber = false } = {},
): Options<string | number, string>[] =>
  data.map((d) => ({
    label: isCapitalizeFirstLetter && !makeValueNumber ? capitalizeFirstLetter(d) : d,
    value: makeValueNumber ? +d : d,
  }));

export const createYesOrNoOptions = (): Options<number, string>[] => [
  { label: 'No', value: 0 },
  { label: 'Yes', value: 1 },
];
